import { DiscoverMainFilter } from "./discover-main-filter";

export const DiscoverHeader = () => {
  return <DiscoverMainFilter />;
};
